import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import "./homepagecomponents.css"
import img1 from "./images/homepage-img2.jpeg"
// import avatar1 from "./images/avatar1.jpg"
// import avatar2 from "./images/avatar2.jpg"
// import avatar3 from "./images/avatar3.jpeg"
// import avatar4 from "./images/avatar4.jpg"
// import avatar5 from "./images/avatar5.jpg"
// import avatar6 from "./images/avatar6.png"

const HomepageComp1 = () => {
  const { t } = useTranslation();
  const ref = useRef();
  const [isVisible, setIsVisible] = useState(false);

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.unobserve(entry.target);
      }
    });
  });

  useEffect(() => {
    const currentRef = ref.current;
    if (currentRef) {
      observer.observe(currentRef);
    }
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [ref]);

  return (
    <div className={`homepage-component-container homepage-comp1-container overflow-hidden ${isVisible ? 'fade-in' : ''}`} ref={ref}>

      <div className='md:grid grid-cols-2 relative gap-[50px]'>

        <div className='homepage-comp1-div3 '>
          <h1 className='homepage-title2'>
            {t('homepage.comp1.title')}
          </h1>

          <p className='homepage-text1'>
            {t('homepage.comp1.description')}
          </p>

          <div className='homepage-link1 z-2 relative'>
            <a  href="/investment-opportunities">
              {t('homepage.comp1.linkBtn')}
            </a>
          </div>
        </div>

        <div className='h-full flex items-end justify-center'>
          <div className='homepage-comp1-div2 z-2'>
            <div className='text-xl text-white'>
              <span className='text-xl font-semibold lg:text-3xl'>
                {t('homepage.comp1.bannerTitle')}
              </span>
              <br />
              <span className=''>
                {t('homepage.comp1.bannerSubtitle')}
              </span>
            </div>
          </div>
        </div>

        <svg className="absolute -bottom-20 right-0 z-0 hidden lg:block" width="1044" height="140" viewBox="0 0 1044 140" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.00006 44.5C88.6667 84.3333 354.9 157.3 546.5 44.4999C738.1 -68.3001 957.833 73.3333 1042 138" stroke="#E9E9E9" strokeWidth="3" strokeLinecap="round" strokeDasharray="20 20"></path>
        </svg>
      </div>

      <img className="homepage-comp1-topimg absolute shadow-md -right-36 -top-20 z-10 hidden h-[800px] w-[800px] rounded-full rounded-tr-none object-cover object-center md:block" src={img1} alt="hero" />

    </div>
  )
}

export default HomepageComp1;